import Vue from 'vue'
import Vuex from 'vuex'

import mutations from "./mutations"
import getters from './getters'
import user from './modules/user';

//挂载Vuex
Vue.use(Vuex)

// const state = {
//     isActive:false,// 基础数据-检查表模板选中显示
// }

//创建VueX对象
const store = new Vuex.Store({
    // state:{
    //     //存放的键值对就是所要管理的状态
    //     userId:'安全信息分类'
    // },
    // mutations:{
    //     //es6语法，等同edit:funcion(){...}
    //     edit(state,payload){
    //         state.userId = payload
          
    //     }
    // }
    //将状态树store 分割成模块 每个模块拥有自己的 state、mutation、action、getter、甚至是嵌套子模块——从上至下进行同样方式的分割
    modules: {
      user, //用户的信息
  },
    //getter（可以认为是 store 的计算属性）对数据的一个过滤和加工
    getters: getters //对以上数据进行加工	

    // state,
    // mutations:mutations,
    // actions: {
    //     asupdateInfo(context, payload){
    //       return new Promise((resolve, reject) =>{
    //         setTimeout(() => {
    //           context.commit({
    //             type: 'updateAge',
    //             age: payload.age
    //           })
    //           resolve(`修改age为 ${payload.age} 成功`)
    //         },2000)
    //       })
    //     }
    //   },
    //   modules: moduleA

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js